<script setup lang="ts">
  import { Stepper } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';

  interface NightsStepperProps {
    label: string;
    value: number;
    min?: number;
    max?: number;
    testid: string;
  }

  const props = withDefaults(defineProps<NightsStepperProps>(), {
    min: 1,
    max: 29,
  });

  interface NightsStepperEmits {
    (e: 'update:value', v: number): void;
  }

  const emit = defineEmits<NightsStepperEmits>();

  const model = computed({
    get: () => props.value,
    set: (value) => emit('update:value', value),
  })
</script>

<template>
  <div class="nights-range-stepper" :data-testid="testid">
      <Stepper
        :min="min"
        :max="max"
        v-model="model"
      />
  </div>
</template>

<style scoped lang="scss">
  .nights-range-stepper {
    align-items: center;
    display: flex;
    gap: var(--spacing-s);

  }
</style>
